export const styles = {
	listItem: {
		'&:hover': {
			backgroundColor: '#efefef'
		}
	}
};
